import React from "react";

import { baseURL } from "Dashboard/EmployerUrls";

import Breadcrumbs from "Common/Breadcrumbs/Breadcrumbs";

const employerHomeCrumb = () => {
  return { title: "Home", link: baseURL };
};

const EmployerBreadcrumbs = ({ crumbs, ...rest }) => {
  crumbs.unshift(employerHomeCrumb());
  const uniqueCrumbs = [...new Map(crumbs.map((crumb: { title: any }) => [crumb.title, crumb])).values()];

  return <Breadcrumbs crumbs={uniqueCrumbs} {...rest} />;
};

export const SimpleEmployerBreadcrumbs = ({ title, ...rest }) => {
  const crumbs = [{ title, link: "" }];

  return <EmployerBreadcrumbs crumbs={crumbs} {...rest} />;
};

export default EmployerBreadcrumbs;
